import React, { useEffect } from 'react';
import SalaryItems from './SalaryItem/SalaryItem';

const CostPanel = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    useEffect(() => {
        document.title = "Redech | Itens do salário"
    }, [])

    return (
        <SalaryItems
            registrationIdsSelected={registrationIdsSelected}
            isActiveFilter={isActiveFilter}
        />
    );
};

export default CostPanel;
